import { isEqual, sum, uniqWith } from 'lodash';
import { segmentGrid, segmentResolution, sheetToGrid } from './sheetToGrid';
export function sheetToPatterns(sheet) {
    return sheet.segments.map(segmentToPattern);
}
export function sheetToPattern(sheet) {
    const signatures = uniqWith(sheet.segments.map(s => s.signature), isEqual);
    if (signatures.length > 1) {
        const signs = signatures.map(({ numerator, denominator }) => `${numerator}/${denominator}`).join(', ');
        throw new Error(`Cannot generate a single pattern with different signatures: ${signs}`);
    }
    const grid = sheetToGrid(sheet);
    return gridToPattern(grid, sum(sheet.segments.map(s => s.measures.length * (s.repeats ?? 1))), { ...sheet.segments[0].signature, tickNote: grid.resolution });
}
export function segmentToPattern(segment) {
    const resolution = segmentResolution(segment);
    const grid = segmentGrid(segment, resolution, 0);
    return gridToPattern(grid, segment.measures.length * ((segment.repeats ?? 0) + 1), { ...segment.signature, tickNote: resolution });
}
function gridToPattern(grid, measures, signature) {
    const hits = grid.ticks.flatMap(({ tick, notes }) => notes.map((note) => ({
        tick, mode: null,
        note: note.pitch != null ? note.pitch : null,
        dynamics: note.dynamics ?? null,
        sticking: note.sticking ?? null,
        lag: note.lag ?? null
    })));
    return { measures, signature, hits };
}
//# sourceMappingURL=sheetToPatterns.js.map